import { createSlice } from "@reduxjs/toolkit";

const initialValues = {
  firstName: "",
  middleName: "",
  lastName: "",
  hireDate: "",
  hrEmployeeId: "",
  email: "",
  jobTitle: { JobTitle: "" },
  hrSystem: { Name: "", CP_HRSystemId: "" },
  employmentType: 0,
  centerLocation: { LocationName: "" },
  employmentStatus: 0,
  statusDate: "",
  supervisor: {
    EmployeeId: 0,
    OracleId: "",
    FirstName: "",
    LastName: "",
    EmployeeStatus: "",
    JobTitle: "",
  },
  comments: "",
  client: { ClientCode: "", ClientName: "" },
  program: { ProgramName: "", ProgramCode: "" },
  project: { ProjectName: "", ProjectCode: "" },
  department: { Name: "", Code: "" },
  productTrainingStartDate: "",
  nestingStartDate: "",
  projectStartDate: "",
  projectEndDate: "",
  productionStartDate: "",
  wave: "",
  projectTableRows: [],
  disableElements: false,
  systemTableRows: [],
  CP_EmployeeId: "",
  nonTTECEmployeeId: "",
  errors: {
    personalInformation: "",
    employmentInformation: "",
    projectInformation: "",
    systemInformation: "",
  },
  editEmployee: false,
  updateMode: false,
  loading: {
    mainPageLoading: false,
    personalInformation: false,
    employmentInformation: false,
    projectInformation: false,
    systemDetails: false,
  },
};

const addNonHRMSEmployeeSlice = createSlice({
  name: "addNonHRMSEmployee",
  initialState: initialValues,
  reducers: {
    updateFirstName(state, action) {
      state.firstName = action.payload;
    },
    updateMiddleName(state, action) {
      state.middleName = action.payload;
    },
    updateLastName(state, action) {
      state.lastName = action.payload;
    },
    updateHireDate(state, action) {
      state.hireDate = action.payload;
    },
    updateHrEmployeeId(state, action) {
      state.hrEmployeeId = action.payload;
    },
    updateJobTitle(state, action) {
      state.jobTitle = action.payload;
    },
    updateHrSystem(state, action) {
      state.hrSystem = action.payload;
    },
    updateEmail(state, action) {
      state.email = action.payload;
    },
    updateEmploymentType(state, action) {
      state.employmentType = action.payload;
    },
    updateCenterLocation(state, action) {
      state.centerLocation = action.payload;
    },
    updateEmploymentStatus(state, action) {
      state.employmentStatus = action.payload;
    },
    updateStatusDate(state, action) {
      state.statusDate = action.payload;
    },
    updateSupervisor(state, action) {
      state.supervisor = action.payload;
    },
    updateComments(state, action) {
      state.comments = action.payload;
    },
    updateClient(state, action) {
      state.client = action.payload;
    },
    updateProject(state, action) {
      state.project = action.payload;
    },
    updateProgram(state, action) {
      state.program = action.payload;
    },
    updateDepartment(state, action) {
      state.department = action.payload;
    },
    updateWave(state, action) {
      state.wave = action.payload;
    },
    updateProductTrainingStartDate(state, action) {
      state.productTrainingStartDate = action.payload;
    },
    updateNestingStartDate(state, action) {
      state.nestingStartDate = action.payload;
    },
    updateProjectStartDate(state, action) {
      state.projectStartDate = action.payload;
    },
    updateProjectEndDate(state, action) {
      state.projectEndDate = action.payload;
    },
    updateProductionStartDate(state, action) {
      state.productionStartDate = action.payload;
    },
    updateProjectTableRows(state, action) {
      state.projectTableRows = action.payload;
    },
    updateDisableElements(state, action) {
      state.disableElements = action.payload;
    },
    updateSystemTableRows(state, action) {
      state.systemTableRows = action.payload;
    },
    updateEmployeeId(state, action) {
      state.CP_EmployeeId = action.payload;
    },
    updateNonTTECEmployeeId(state, action) {
      state.nonTTECEmployeeId = action.payload;
    },
    updatePersonalInformationError(state, action) {
      state.errors.personalInformation = action.payload;
    },
    updateEmploymentInformationError(state, action) {
      state.errors.employmentInformation = action.payload;
    },
    updateProjectInformationError(state, action) {
      state.errors.projectInformation = action.payload;
    },
    updateSystemInformationError(state, action) {
      state.errors.systemInformation = action.payload;
    },
    updateEditEmployee(state, action) {
      state.editEmployee = action.payload;
    },
    updateMode(state, action) {
      state.updateMode = action.payload;
    },
    updateMainPageLoading(state, action) {
      state.loading.mainPageLoading = action.payload;
    },
    updatePersonalInformationLoader(state, action) {
      state.loading.personalInformation = action.payload;
    },
    updateEmploymentInformationLoader(state, action) {
      state.loading.employmentInformation = action.payload;
    },
    updateProjectInformationLoader(state, action) {
      state.loading.projectInformation = action.payload;
    },
    updateSystemDetailsLoader(state, action) {
      state.loading.systemDetails = action.payload;
    },
    updateAllValues(state, action) {
      return {
        ...action.payload,
        CP_EmployeeId: state.CP_EmployeeId,
        projectTableRows: [],
        disableElements: false,
        systemTableRows: [],
        loading: {
          mainPageLoading: false,
          personalInformation: false,
          employmentInformation: false,
          projectInformation: false,
          systemDetails: false,
        },
        errors: {
          personalInformation: "",
          employmentInformation: "",
          projectInformation: "",
          systemInformation: "",
        },
      };
    },
    resetState() {
      return initialValues;
    },
  },
});

export const addNonHRMSEmployeeActions = addNonHRMSEmployeeSlice.actions;

export default addNonHRMSEmployeeSlice.reducer;
